import { useEffect } from "react";

/**
 * Shortcut route → /regenerated.html static viewer page.
 */
export default function RegeneratedRedirect() {
  useEffect(() => {
    window.location.replace("/regenerated.html");
  }, []);
  return (
    <div style={{ padding: "80px 24px", textAlign: "center", color: "#6b6255", fontFamily: "system-ui, sans-serif" }}>
      Opening the regenerated-buddies viewer…
    </div>
  );
}
